// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

export default useStyles;
